import React, { useState } from "react";
import { Formik, Form, Field, Textarea, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GiCrossedBones } from 'react-icons/gi';
import { LuSave } from 'react-icons/lu';
import { submitMotorAddOnsMaster } from "../../../../services/apiService";

const AddMotorAddOns = () => {

  // Form Validation Schema
  const validationSchema = Yup.object({
    addOnName: Yup.string().required("Addon Name is required"),
  });

  //   const generateRandomNumber = () => {
  //     return Math.floor(Math.random() * 90) + 10; // Generates a number between 10 and 99
  //   };

  // Submit Whole Form
  const handleSubmit = async (values, { resetForm }) => {
    try {
      const formattedData = {
        TObject: {
          Motor_AddOn_ID: 0, // assuming new product
          addOnName: values.addOnName, // ensure it's a number
          Description: values.addonDescription,
          CreatedBy: 1,
        }
      };

      // Call API
      await submitMotorAddOnsMaster(formattedData);

      alert("Form submitted successfully!");

      // Reset form after successful submission
      resetForm();
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  };

  return (
    <div className="formContainer  lg:p-5">
      <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">Motor Addon Master</h5>
        {/* Formik Form */}
        <Formik
          initialValues={{
            addOnName: "",
            addonDescription: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form id="motorAddOnsForm">
              <div className="row">
                <div className="col-md-6 w-1/2">
                  <label className="form-label">Addon Name <span className="text-danger">*</span>
                  </label>
                  <Field type="text" name="addOnName" className="form-control custom-shadow" />
                  <ErrorMessage name="addOnName" component="div" className="text-danger" />
                </div>
                <div className="col-md-12 w-1/2 mt-3">
                  <label className="form-label">Description</label>
                  <Field as="textarea" name="addonDescription" className="form-control custom-shadow" rows="4" />
                </div>
              </div>

              <div className="d-flex justify-content-start gap-3 mt-5 justify-content-center">
                <button type="submit" className=" saveButton d-flex" disabled={isSubmitting}>
                  <span className="m-auto p-1"><LuSave /></span>{isSubmitting ? "Saving..." : "Save"}
                </button>
                <div className="flex gap-3">
                  <button type="button" className="d-flex  backButton d-flex" onClick={() => window.history.back()}> <span className="m-auto p-1"><GiCrossedBones /></span>Cancel</button>
                </div>
              </div>
              {/* Submit Button */}
              {/* <div className="mt-4 d-flex justify-content-left">
              <button type="submit" className="btn btn-warning text-white" disabled={isSubmitting}>
                Save
              </button>
            </div> */}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddMotorAddOns;